import _ from 'lodash';
import { useRef } from 'react';
import { useNewPaymentCardModal } from '../screens/payment/new-payment-card-modal';
import { usePaymentCardDeleteModal } from '../screens/payment/payment-card-delete-modal';
import { usePaymentCardDeletedModal } from '../screens/payment/payment-card-deleted-modal';
import { useSelectPaymentCardModal } from '../screens/payment/select-payment-card-modal';

function usePaymentCardWorkflow() {
  const { prepareSelectCardModal, showSelectCardModal } =
    useSelectPaymentCardModal();
  const { prepareNewPaymentCardModal, showNewPaymentCardModal } =
    useNewPaymentCardModal();
  const { showPaymentCardDeleteModal } = usePaymentCardDeleteModal();
  const { showPaymentCardDeletedModal } = usePaymentCardDeletedModal();

  const prepareResultRef = useRef();
  const ordersRef = useRef();
  const tipAmountRef = useRef();

  async function prepare({ orders, tipAmount } = {}) {
    ordersRef.current = orders;
    tipAmountRef.current = tipAmount;

    let result = await prepareSelectCardModal({
      orders,
      tipAmount,
    });

    const newPaymentResult = await prepareNewPaymentCardModal({
      orders,
      tipAmount,
    });

    if (!result.hasCards) {
      result = _.merge(result, newPaymentResult);
    }

    prepareResultRef.current = result;
  }

  async function show({ prepareOnPreConfirm, prepareOnPreDeny } = {}) {
    let repeat = false;
    let result = prepareResultRef.current;

    if (result.byPass) return result;

    /* eslint-disable no-await-in-loop */
    do {
      if (result.hasCards) {
        const showResult = await showSelectCardModal({
          prepareOnPreConfirm,
          prepareOnPreDeny,
        });
        result = _.merge(result, showResult);
      }

      if (result.hasCards && result.wasDeleteCardClicked) {
        const showResult = await showPaymentCardDeleteModal({
          card: result.cardToDelete,

          // eslint-disable-next-line no-loop-func
          prepareOnPreConfirm: async () => {
            const prepareResult = await prepareSelectCardModal({
              orders: ordersRef.current,
              tipAmount: tipAmountRef.current,
            });

            result = _.merge(result, prepareResult);
          },
        });

        if (showResult.isConfirmed) {
          await showPaymentCardDeletedModal();
        }

        result = _.merge(result, showResult);
      }

      if (!result.hasCards || result.wasOtherCardClicked) {
        const showResult = await showNewPaymentCardModal({
          showBackButton: result.wasOtherCardClicked,
          prepareOnPreConfirm,
          prepareOnPreDeny,
        });

        result = _.merge(result, showResult);
      }

      repeat =
        (result.wasDeleteCardClicked && !result.isDenied) ||
        (result.wasOtherCardClicked && result.isDenied);
    } while (repeat);

    return result;
  }

  return {
    preparePaymentCardWorkflow: prepare,
    showPaymentCardWorkflow: show,
  };
}

export { usePaymentCardWorkflow };
